import { useSettings } from "@/context/SettingsContext";
import { BrandMark } from "@/components/common/BrandMark";

export default function AuthLayout({ title, subtitle, children, footer, testid }) {
  const { settings } = useSettings();
  return (
    <div className="auth-backdrop flex min-h-screen flex-col items-center justify-center px-4 py-12" data-testid={testid}>
      <div className="w-full max-w-[420px]">
        <div className="mb-8 flex items-center gap-3">
          <BrandMark />
          <span className="text-base font-semibold" data-testid="auth-hub-name">{settings.hub_name}</span>
        </div>
        <div className="card-elevated p-8">
          <h1 className="text-lg font-semibold">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
        <p className="mt-10 text-xs text-muted-foreground">Internal to Fuse Capital. Access is by invitation only.</p>
      </div>
    </div>
  );
}
